export const getCargoStatusName = (cargoStatus?: string) => {
  switch (cargoStatus) {
    case 'IND':
      return 'Kargoya verildi';
    case 'DLV':
      return 'Teslim edildi';
    default:
      return 'Henüz işleme alınmadı';
  }
};
